interface AnalyticsRoute {
  pattern: RegExp;
  pagePath: string;
  pageName: string;
}

const DYNAMIC_ROUTES: AnalyticsRoute[] = [
  {
    pattern: /^\/messages\/[^/]+\/details$/,
    pagePath: '/messages/:conversationId/details',
    pageName: 'chat_details',
  },
  {
    pattern: /^\/messages\/[^/]+$/,
    pagePath: '/messages/:conversationId',
    pageName: 'chat',
  },
  {
    pattern: /^\/profile\/others\/[^/]+\/connections$/,
    pagePath: '/profile/others/:userGuid/connections',
    pageName: 'connections',
  },
  {
    pattern: /^\/profile\/others\/[^/]+$/,
    pagePath: '/profile/others/:userGuid',
    pageName: 'other_profile',
  },
  {
    pattern: /^\/groups\/[^/]+\/edit$/,
    pagePath: '/groups/:groupId/edit',
    pageName: 'edit_group',
  },
  {
    pattern: /^\/groups\/[^/]+$/,
    pagePath: '/groups/:groupId',
    pageName: 'group_details',
  },
  {
    pattern: /^\/survey\/[^/]+$/,
    pagePath: '/survey/:questionId',
    pageName: 'survey_question',
  },
  {
    pattern: /^\/post\/[^/]+$/,
    pagePath: '/post/:postId',
    pageName: 'post_deep_link',
  },
  {
    pattern: /^\/group\/[^/]+$/,
    pagePath: '/group/:groupId',
    pageName: 'group_deep_link',
  },
  {
    pattern: /^\/(?:profile|u)\/[^/]+$/,
    pagePath: '/profile/:userId',
    pageName: 'profile_deep_link',
  },
];

const STATIC_PAGE_NAMES: Record<string, string> = {
  '/': 'home',
  '/buddies': 'buddies',
  '/create': 'create_post',
  '/groups/create': 'create_group',
  '/groups/my': 'my_groups',
  '/login': 'login',
  '/messages': 'messages',
  '/notifications': 'notifications',
  '/profile': 'profile',
  '/profile/connections': 'connections',
  '/profile/edit': 'edit_profile',
  '/profile/portrait': 'profile_portrait',
  '/robi': 'robi',
  '/signup': 'sign_up',
};

export const resolveAnalyticsRoute = (
  pathname: string,
): { pagePath: string; pageName: string } => {
  const normalized = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  const staticPageName = STATIC_PAGE_NAMES[normalized];
  if (staticPageName) {
    return { pagePath: normalized, pageName: staticPageName };
  }

  const dynamic = DYNAMIC_ROUTES.find(route => route.pattern.test(normalized));
  if (dynamic) {
    return { pagePath: dynamic.pagePath, pageName: dynamic.pageName };
  }
  return {
    pagePath: normalized,
    pageName: normalized.split('/').filter(Boolean).join('_') || 'home',
  };
};

/** Removes query data and identifier-bearing paths from a browser referrer. */
export const sanitizeAnalyticsReferrer = (
  referrer: string,
  appOrigin: string,
): string => {
  if (!referrer) return '';
  try {
    const url = new URL(referrer);
    if (url.origin !== appOrigin) {
      return url.origin;
    }
    const route = resolveAnalyticsRoute(url.pathname);
    return `${url.origin}${route.pagePath}`;
  } catch {
    return '';
  }
};

/** Deduplicates one React effect replay without comparing redacted templates. */
export const createNavigationDeduplicator = () => {
  let lastNavigationIdentity = '';
  return (navigationIdentity: string): boolean => {
    if (navigationIdentity === lastNavigationIdentity) return false;
    lastNavigationIdentity = navigationIdentity;
    return true;
  };
};
